/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import { Modal, Button } from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { callAPI } from 'lorautils/api';
import styles from './styles.scss';

const defaultProps = {
  show: false,
};

const propTypes = {
  intl: React.PropTypes.object.isRequired,
  show: React.PropTypes.bool.isRequired,
  onHide: React.PropTypes.func.isRequired,
  onDeleted: React.PropTypes.func.isRequired,
  flow: React.PropTypes.object.isRequired,
};

class DeleteFlowModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
      flow: props.flow,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.flowsview.flows.delete');
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { show, flow } = nextProps;
    if (show !== this.props.show) {
      this.setState({ show });
    }
    if (flow !== this.props.flow) {
      this.setState({ flow });
    }
  }

  handleSubmit() {
    const { onDeleted } = this.props;
    const { flow } = this.state;
    callAPI({
      endpoint: `/lora/flows/${flow.id}`,
      method: 'DELETE',
    }).then(() => {
      onDeleted();
    }).catch(() => {});
  }

  render() {
    const { onHide } = this.props;
    const { show, flow } = this.state;
    return (
      <Modal bsClass="aisz-modal-danger" show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <div className="text-center">
            <i className="fa fa-exclamation-triangle" />{' '}
            {this.intlMsg.msg('header')}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className={styles.body}>
            {this.intlMsg.msg('rusure')}
            <span className={styles.name}>{flow.name}</span>
            ?
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className={styles.buttons}>
            <Button bsStyle="aisz-warning" onClick={onHide}>{this.intlMsg.msg('cancel')}</Button>
            <Button bsStyle="aisz-danger" onClick={this.handleSubmit}>{this.intlMsg.msg('submit')}</Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

DeleteFlowModal.propTypes = propTypes;
DeleteFlowModal.defaultProps = defaultProps;

export default injectIntl(DeleteFlowModal);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/FlowsView/coms/DeleteFlowModal/index.jsx